import Image from 'next/image'

import type { FC } from 'react'
import type { IClientsData } from '@/types'

const OurClientCard: FC<IClientsData> = ({ image, name }) => {
  return (
    <div className="mx-1 flex h-[50px] w-[127px] items-center justify-center overflow-hidden rounded-lg bg-white px-4 py-2 md:mx-3 md:h-[96px] md:w-[227px] md:rounded-xl md:px-8 md:py-5">
      <Image src={image} alt={name} width={200} height={100} className="h-full object-contain" />
    </div>
  )
}

export default OurClientCard
